/* src/app/my-candidates/my-candidates.component.scss */
@keyframes shimmer {
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
}
.sk-box {
  border-radius: 10px;
  background:
    linear-gradient(
      90deg,
      #f0f0f0 25%,
      #e0e0e0 50%,
      #f0f0f0 75%);
  background-size: 1200px 100%;
  animation: shimmer 1.6s infinite linear;
  flex-shrink: 0;
}
.skeleton-page {
  background: #fff;
  border-radius: 8px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
  font-size: 0;
}
.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-actions {
  display: flex;
  gap: 6px;
}
.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}
.title-bar {
  width: 180px;
  height: 10px;
}
.icon-btn {
  width: 24px;
  height: 22px;
  border-radius: 4px;
}
.btn-lg {
  width: 110px;
  height: 28px;
  border-radius: 5px;
}
.btn-md {
  width: 80px;
  height: 28px;
  border-radius: 5px;
}
.subtitle-row {
  padding-left: 24px;
  margin-bottom: 6px;
}
.subtitle {
  width: 280px;
  height: 6px;
  border-radius: 10px;
}
.breadcrumb-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 24px;
}
.crumb {
  height: 6px;
  border-radius: 10px;
}
.crumb--sm {
  width: 80px;
}
.crumb--md {
  width: 120px;
}
.crumb--lg {
  width: 180px;
}
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex-shrink: 0;
}
.chips-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.chip-label {
  width: 90px;
  height: 6px;
}
.chip {
  height: 16px;
  border-radius: 12px;
  min-width: 60px;
}
.data-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.data-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
}
.row-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}
.row-title {
  height: 13px;
  border-radius: 10px;
}
.meta-tag {
  height: 7px;
  border-radius: 10px;
}
.row-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-card {
  height: 28px;
  border-radius: 5px;
}
.button {
  height: 28px;
  width: 115px;
  position: relative;
  border-radius: 0px 8px 8px 0px;
  background-color: #f4f4f4;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0px;
  box-sizing: border-box;
}
.button-child {
  height: 28px;
  width: 16px;
  position: relative;
  flex-shrink: 0;
}
.vector-icon {
  height: 28px;
  width: 100%;
  position: relative;
  background-color: #eeeeee;
}
@media (prefers-reduced-motion: reduce) {
  .sk-box {
    animation: none;
    background: #eeeeee;
  }
}
.table-sk-view,
.table-sk-3-column-view {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  width: 100%;
}
.table-sk-view .table-sk-header,
.table-sk-3-column-view .table-sk-header {
  background: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
}
.table-sk-view .table-body-row,
.table-sk-3-column-view .table-body-row {
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
  background-color: #fff;
}
.table-sk-view .table-sk-col,
.table-sk-3-column-view .table-sk-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
  width: 30%;
}
.table-sk-view .table-sk-col:last-child,
.table-sk-3-column-view .table-sk-col:last-child {
  border-right: none;
  width: 70%;
}
.table-sk-3-column-view .table-sk-3-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
}
.table-sk-3-column-view .table-sk-3-col:last-child {
  border-right: none;
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:nth-of-type(2) {
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:first-child {
  width: 30%;
}
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #969696;
  display: flex;
  background:
    linear-gradient(
      0deg,
      #F4F4F4 0%,
      #F4F4F4 100%),
    #FFF;
}
.common-chip .spinner-border {
  width: 12px;
  height: 12px;
  border-width: 1px;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.excellent {
  border-radius: 6px;
  color: #39B141;
  background:
    linear-gradient(
      0deg,
      rgba(57, 177, 65, 0.1) 0%,
      rgba(57, 177, 65, 0.1) 100%),
    #FFF;
}
.error {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.good {
  border-radius: 6px;
  color: #9CC535;
  background:
    linear-gradient(
      0deg,
      rgba(156, 197, 53, 0.1) 0%,
      rgba(156, 197, 53, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.criteria-label.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.criteria-label.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.criteria-label.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.good-fit {
  background: #F5F9F2;
  color: #9CC535;
}
.criteria-label.good-fit {
  background: #F5F9F2;
  color: #9CC535;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  border: 0;
  outline: none;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
}
.toggle-container .activebtn {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.br-1 {
  border-right: 1px solid #E5E5E5;
}
.mainContainer {
  display: flex;
  gap: 15px;
}
.projectScreenWidth {
  width: calc(100% - 215px);
}
.projectlistsidepanel {
  padding: 6px;
  border-radius: 4px;
  width: 200px;
  background-color: #ffffff;
}
.recommended-empty-screen {
  margin: 0 auto;
  width: 480px;
}
.howitworks {
  width: 70%;
  margin: 0 auto;
  padding: 10px 10px;
  border-radius: 4px;
  background-color: #F2F2F2;
}
label {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 500;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
::ng-deep .ngb-candidate-slider {
  width: 75% !important;
}
.criteria-label {
  display: flex;
  height: 24px;
  padding: 6px 9px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 14px;
  background-color: #F5F5F5;
  font-size: 12px;
  font-weight: 500;
}
.excellent-match {
  background-color: rgba(34, 147, 0, 0.1);
  color: #229300;
}
.w-100px {
  width: 100px;
}
.highlight-chip-container {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0px;
  align-items: center;
}
.highlight-chips {
  display: flex;
  padding: 5px 10px 5px 5px;
  align-items: flex-start;
  gap: 10px;
  color: #484B59;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 6px;
  margin-right: 6px;
  border-radius: 19px;
  border: 1px solid #F2F2F2;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
.ai-summary {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  font-size: 12px;
  font-weight: 500;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text-summary {
  color: #E24F80;
}
.email-contact-badge {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  line-height: 0.5;
  border-radius: 4px;
  background: rgba(46, 147, 161, 0.1);
  height: 20px;
}
.btn-rerunAI-screening {
  display: flex;
  width: 142px;
  height: 28px;
  padding: 3px 8px;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  outline: none;
  border: none;
  margin-right: 10px;
  background:
    linear-gradient(
      267deg,
      rgba(200, 69, 171, 0.1) 15.14%,
      rgba(226, 78, 127, 0.1) 52.19%);
}
.btn-rerunAI-screening span.text {
  color: #D74B92;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
::ng-deep .highlight-chip-container {
  position: relative;
}
::ng-deep .highlight-chip-container .highlight-chips:first-child + ngb-tooltip-window {
  transform: translateX(102px) !important;
}
::ng-deep ngb-tooltip-window .tooltip-inner {
  max-width: 400px;
  padding: 0.5rem 0.5rem;
  color: #ffffff;
  text-align: left;
  background-color: #484b59;
  border-radius: 0.25rem;
  width: fit-content;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  will-change: inherit !important;
  border: 1px solid #484b59;
}
hr.highlight-tooltip-divider {
  margin: 8px 0;
}
.hiderule:last-child hr {
  display: none;
}
.contact-reveal {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  line-height: 0.5;
  border-radius: 4px;
  background: rgba(46, 147, 161, 0.1);
  height: 20px;
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
}
.contact-reveal:hover {
  opacity: 1;
}
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
.bg-input {
  width: 85%;
  color: #484b59;
  background-color: #eaeaea !important;
  border: 1px solid #ecf0f4;
  border-radius: 2px;
  padding: 10px;
}
.bq-div {
  width: calc(100% - 200px);
}
.w-200px {
  width: 200px;
  display: flex;
  align-items: center;
}
.copy-btn {
  padding: 10px 20px;
  position: absolute;
  left: 0;
  top: -21px;
}
.btn-position {
  position: absolute;
  right: -25px;
  width: 110px;
}
.boolean-input {
  overflow: hidden;
  line-height: 1.3;
  resize: none;
}
.copy-btn-search {
  padding: 7px;
  width: 90px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ecf0f4;
  border-left: none;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.w-100px {
  width: 130px;
}
.circular-img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
}
.rightsideclose.mat-chip.mat-standard-chip {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-direction: row-reverse;
}
.isActive {
  color: #2e93a1 !important;
}
.card {
  border-left: none;
  border-right: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header {
  padding: 0.5rem 0;
  margin-bottom: 0;
  background-color: hsla(0, 0%, 100%, 0.03);
  border-bottom: none;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.collapse:not(.show) {
  display: none;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
.btn-link {
  font-weight: 400;
  text-decoration: none;
  color: #2c2c2c;
}
.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed {
  color: #2c2c2c;
}
.collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.wcAccordianUpDownArrow {
  right: 0;
  justify-self: flex-end;
}
.underline-on-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
.show-on-hover {
  display: none;
}
.hoverable-element:hover .show-on-hover {
  display: block;
}
.add-to-talentpool {
  padding-top: 7px;
  padding-bottom: 7px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  border: solid 0.5px #2e93a1;
  background-color: #ffffff;
  padding: 6px 12px;
  height: 35px;
}
.reset-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background-color: #969696;
  color: #fff;
}
.static ~ .toggle .up {
  display: block;
}
.static ~ .toggle .down {
  display: none;
}
.static.collapsed ~ .toggle .up {
  display: none;
}
.static.collapsed ~ .toggle .down {
  display: block;
}
.empty-state-img {
  width: 138.92px;
  height: 177.81px;
}
.new-form {
  width: 125px;
  height: 25px;
  padding: 1px 6px 2px 4px;
  border-radius: 4px;
  border: solid 1px #d5dee6;
  background-color: #fff;
}
.wc-form-control:focus {
  border-color: #2E93A1;
  outline: none;
}
.new-form:focus {
  border-color: #2E93A1;
  outline: none;
}
.f-13 {
  font-size: 13px;
  line-height: 1.3;
}
.mat-chip.mat-standard-chip .mat-chip-remove {
  color: rgba(0, 0, 0, 0.87);
  opacity: inherit !important;
}
.excluded-chip {
  background-color: #fae7e7 !important;
}
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.male-box {
  height: 8px;
  flex-grow: 0;
}
ul {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.lavender-circle {
  background-color: #E1D8E9 !important;
  color: #725190 !important;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.teal-circle {
  color: #34A853;
  background-color: #EBF6EE;
}
::ng-deep .mat-table {
  font-family: "Poppins", sans-serif !important;
}
.skills-chip {
  background-color: #e4f1f3;
  border-radius: 16px;
  min-height: 26px;
  font-weight: 500;
  font-size: 12px;
}
.bg-chip {
  background-color: #e4f1f3;
}
.bg-ai-chip {
  background-color: rgba(226, 78, 127, 0.05);
}
.hoverToShowGuideline {
  cursor: pointer;
}
.hoverToShowGuideline:hover i {
  color: #2e93a1;
}
.hoverToShowGuideline:hover .searchGuide {
  width: calc(100% - 125px);
  display: block;
  transition: display 0.5s;
}
.hoverToShowGuideline:hover .searchResutlBackdrop {
  display: block;
}
.searchGuide {
  width: 100%;
  background-color: white;
  display: none;
  transition: display 0.5s;
  position: fixed;
  top: 70px;
  left: 95px;
  padding: 20px;
  z-index: 4;
  text-align: left;
}
.hoverable-class:hover {
  cursor: pointer;
}
.red-dot {
  color: #CD0F0F;
  font-size: 28px;
  position: absolute;
  top: 8px;
  left: 90px;
}
.loader {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader img {
  width: 60px;
}
.loader.small {
  height: 200px;
}
.loader.medium {
  height: 365px;
}
.loader.big {
  height: 400px;
}
.compnaylogoplaceholder {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4f1f3;
  padding: 5px;
}
.compnaylogoplaceholder img {
  width: 100%;
  height: auto;
}
.compnaylogoplaceholder i {
  color: #2e93a1;
}
.compnaylogoplaceholder-chip {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4f1f3;
}
.compnaylogoplaceholder-chip img {
  width: 100%;
  height: auto;
}
.compnaylogoplaceholder-chip i {
  color: #2e93a1;
}
.company-mat-chip mat-chip {
  padding: 5px 10px 5px 5px;
}
#top2,
#viewless2,
#top4,
#viewless4 {
  display: none;
}
.ml-8 {
  margin-left: 35px;
}
.save-search-btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: solid 0.5px #2E93A1;
  background-color: #fff;
  padding: 8px 20px;
  white-space: nowrap;
}
.newCompCard {
  border-radius: 2px;
  background-color: #fff;
  padding: 15px 15px;
  height: 100%;
}
.newCompCard img {
  width: 70px;
  height: 70px;
}
.compLogoIcon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4f1f3;
  margin-right: 15px;
  font-size: 20px;
  overflow: hidden;
}
.compLogoIcon img {
  width: 100%;
  height: auto;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.chipsnew {
  background-color: #e4f1f3;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 6px;
  max-width: 150px;
  width: 150px;
  margin-bottom: 5px;
}
.containerheight {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.filterScrollFix {
  height: 97vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 42vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.filterScrollFix::-webkit-scrollbar {
  width: 4px;
}
.filterScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.filterScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.filterScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.filterScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.talentCountFixonScroll {
  position: sticky;
  top: 0px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.onscrollStickTop {
  position: sticky;
  top: 40px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.card-data {
  height: 130px;
}
.dropdown-toggle::after {
  border-top: none;
}
.four-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  padding: 5px 18px;
  cursor: pointer;
}
.four-matrix p {
  color: #969696;
}
.four-matrix:hover {
  background-color: #f2f2f2;
}
.four-matrix:hover p {
  color: var(--Primary-Text);
}
.diversity-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  cursor: pointer;
}
.gender-ratio {
  width: 50%;
  padding-top: 8px;
  padding-bottom: 2px;
  cursor: pointer;
}
.gender-ratio p {
  color: #969696;
}
.gender-ratio:hover {
  background-color: #f2f2f2;
}
.gender-ratio:hover p {
  color: var(--Primary-Text);
}
.gender {
  text-align: center;
}
.redirect-report {
  background-image: url(/assets/redirect-bg.png);
}
.redirect-filter {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: solid 1px #d9d9d9;
}
.redirect-filter-others {
  color: #484b59;
  font-size: 14px;
}
.redirect-dot {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  background-color: #969696;
}
.dumy-placeholder {
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  line-height: 1.3;
}
.default-placeholder {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  line-height: 1.3;
}
.pjt-red-dot {
  margin-left: 2rem;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn .dropdown-toggle::after {
  border-top: none;
  outline: none;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  transform: translate3d(-35px, 8px, -5px) !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 4px;
  width: fit-content;
  min-width: 110px;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #fff;
}
.ats-dropBtn.slider-drop .dropdown-menu.show {
  transform: translate3d(-213px, 26px, 0px) !important;
  padding: 8px 0 !important;
}
.disabled-input {
  background-color: #eaeaea !important;
}
.enable-input {
  pointer-events: pointer;
}
.region-box {
  width: 120px;
  border-radius: 4px;
  overflow: hidden;
}
.border-blue {
  border: 2px solid #2e93a1;
}
.border-gray {
  border: 1px solid #cacaca;
}
.scrolltopback {
  position: sticky;
  top: 0;
  z-index: 4;
}
.searchScrollFix {
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.searchScrollFix::-webkit-scrollbar {
  width: 4px;
}
.searchScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.searchScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.searchScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.searchScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.locationUnit {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 5px 10px;
  height: 36px;
  margin-bottom: 10px;
}
.disabled-btn-experience {
  width: 80px;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  height: 30px;
  min-width: 80px;
  font-weight: normal;
  color: #484b59;
  background-color: #ccc;
  border: 0px;
}
.btn-trms-xs-small {
  width: 80px;
  padding: 5px 10px;
  border: 1px solid #2e93a1;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  background-color: #2e93a1;
  height: 30px;
  min-width: 80px;
  font-weight: normal;
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      258deg,
      #c845ab 84%,
      #e24e7f 49%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.leading_icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #e24e7f;
}
.highlight-pill {
  max-width: max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 4px 8px;
  border-radius: 30px;
  align-items: center;
  font-weight: 12px;
  cursor: pointer;
  font-weight: 400;
}
.highlight-pill img {
  width: 12px;
}
.companyCompareStick {
  height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 15px;
  z-index: 1;
}
.companyCompareStick::-webkit-scrollbar {
  width: 4px;
}
.companyCompareStick:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.companyCompareStick::-webkit-scrollbar-track {
  background: white !important;
}
.companyCompareStick::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.companyCompareStick::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.companyCompareStick .onscrollStickTop {
  position: sticky;
  top: 0px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.gen-ai-text {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
.excellent-match-check {
  border: 1px solid #229300;
  background: #E0F0DB;
  border-radius: 5px;
  padding: 9px 10px;
  color: #229300;
}
.potential-match-check {
  border: 1px solid #FBA744;
  background: #FEF2E5;
  border-radius: 5px;
  padding: 9px 10px;
  color: #FBA744;
}
.good-match-check {
  border: 1px solid #C5C955;
  background: #F7FAED;
  border-radius: 5px;
  padding: 9px 10px;
  color: #C5C955;
}
.not-match-check {
  border: 1px solid rgba(205, 15, 15, 0.5490196078);
  background: #FAE7E7;
  border-radius: 5px;
  padding: 9px 10px;
  color: rgba(205, 15, 15, 0.5490196078);
}
.tooltip-overflow-text {
  min-width: 100px;
  overflow: hidden;
  display: inline-block;
}
.save-btn {
  border: 1px solid #cfd8dc;
  background: #f8fafb;
  padding: 6px 12px;
  border-radius: 4px;
  color: #2E93A1 !important;
  font-weight: 500;
}
.save-btn:hover {
  background: #eef3f5;
}
.custom-dropdown {
  min-width: 180px;
  padding: 6px 0;
  border-radius: 6px;
  border: 1px solid #e0e6ed;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.custom-dropdown .dropdown-item {
  font-size: 12px;
  padding: 8px 12px;
  color: #2E93A1 !important;
}
.custom-dropdown .dropdown-item:hover {
  background-color: #F5F5F5 !important;
}
.dropdown-item i {
  font-size: 12px;
  color: #2E93A1 !important;
}
.toggle-icon {
  font-size: 12px;
}
select option:hover {
  background-color: #f2f2f2 !important;
  color: white;
}
select.wc-select option:hover {
  box-shadow: 0 0 10px 100px #1882A8 inset;
  background-color: #f2f2f2 !important;
  color: #484b59 !important;
}
select.wc-form-control option:hover {
  background-color: #f2f2f2 !important;
  color: white;
}
:ng-deep .mdc-evolution-chip-set__chips mat-chip-row .big-chip.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background-color: #e4f1f3 !important;
}
:ng-deep .mdc-evolution-chip-set__chips mat-chip-row .bg-ai-chip.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background-color: rgba(226, 78, 127, 0.05) !important;
}
button {
  outline: none !important;
}
button:focus-visible {
  outline: none !important;
}
button:active {
  outline: none !important;
}
::ng-deep div.mat-mdc-autocomplete-panel {
  padding: 6px 0 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar {
  width: 4px;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb {
  background: #969696 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel .mat-mdc-option {
  min-height: 30px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: inherit !important;
}
::ng-deep p-multiselect .p-multiselect-header {
  height: 32px;
}
::ng-deep p-multiselect .p-multiselect-header p-checkbox {
  position: absolute;
  left: 15px;
}
.companylogo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bg-blue-card {
  background: rgb(234, 246, 255);
  padding: 12px 12px;
  border-radius: 8px;
}
.bg-blue-card .user-icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(176, 220, 255);
  color: #000000;
}
.bbgray {
  border-bottom: 1px solid #D9D9D9;
}
.ai-text {
  position: absolute;
  top: -1px;
  font-size: 10px;
  background:
    linear-gradient(
      180deg,
      #9F38F0 0%,
      #E54F7A 100%);
  color: transparent;
  background-clip: text;
}
.progress-container {
  width: 100%;
  height: 10px;
  background:
    linear-gradient(
      180deg,
      rgba(200, 69, 171, 0.1) 0%,
      rgba(226, 78, 127, 0.1) 100%);
  border-radius: 10px;
  overflow: hidden;
}
.progress-bar {
  height: 100%;
  background:
    linear-gradient(
      180deg,
      #C845AB 0%,
      #E24E7F 100%);
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  transition: width 0.05s linear;
}
.filter-btn {
  background-color: #fff;
  color: #2E93A1 !important;
  border: none;
  padding: 12px;
  text-align: center;
  min-width: auto;
  display: flex;
  justify-content: center;
  height: auto;
}
.upload-candidate-btn {
  border: 1px solid #D9D9D9;
  padding: 12px;
  color: #484B59;
  font-size: 14px;
  font-weight: 500;
  height: auto;
}
.upload-candidate-btn .upload-icon {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 10px;
}
.filter-icon .dropdown-toggle::after {
  display: none;
}
.filter-icon .dropdown-menu.show {
  position: absolute;
  transform: translate3d(-252px, 38px, 0px) !important;
}
.checkbox-custom,
.radio-custom {
  opacity: 0;
  position: absolute;
  right: 0;
}
.checkbox-custom,
.checkbox-custom-label,
.radio-custom,
.radio-custom-label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
  font-size: 14px;
}
.checkbox-custom-label,
.radio-custom-label {
  position: relative;
  width: 290px;
  padding: 3px 12px;
  font-size: 14px;
}
.checkbox-custom + .checkbox-custom-label:before,
.radio-custom + .radio-custom-label:before {
  content: "";
  background: #fff;
  border: 2px solid #2E93A1;
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  padding: 2px;
  margin-right: 10px;
  text-align: center;
  position: absolute;
  right: 0;
}
.checkbox-custom:checked + .checkbox-custom-label:before {
  content: "\f00c";
  font-family: "FontAwesome";
  font-family: "Font Awesome 6 Pro";
  font-weight: 900;
  background: #2E93A1;
  color: #fff;
  font-size: 10px;
}
.radio-custom + .radio-custom-label:before {
  border-radius: 50%;
}
.radio-custom:checked + .radio-custom-label:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #fff;
  background-color: #2E93A1;
  font-size: 10px;
  position: absolute;
  right: 0;
}
.checkbox-custom:focus + .checkbox-custom-label,
.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd;
}
.sidebar-card {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  background-image: url("./media/gradient-1-OJJYNV7R.svg");
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  margin-bottom: 15px;
  position: sticky;
  top: 72px;
}
.sidebar-card {
  width: 100%;
  height: 90vh;
  background-color: rgba(255, 255, 255, 0.3);
  background-image: url("./media/gradient-1-OJJYNV7R.svg");
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  margin-bottom: 15px;
}
.empty-resume-upload-card {
  width: 100%;
  height: auto;
  background-color: #E4F1F3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed rgb(46, 147, 161);
}
.empty-resume-upload-card img {
  width: 90px;
  height: auto;
  margin-bottom: 10px;
}
.empty-resume-upload-card p.f-14 {
  font-weight: 600;
  color: rgb(46, 147, 161);
  margin-bottom: 6px;
}
.empty-resume-upload-card p.f-12 {
  font-weight: 300;
  color: rgb(150, 150, 150);
  margin-bottom: 5px;
}
.empty-resume-upload-card .p-55 {
  padding-top: 3%;
  padding-bottom: 3%;
}
.ready-to-run-screen {
  width: 100%;
  height: auto;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      180deg,
      rgba(200, 69, 171, 0.05) 0%,
      rgba(226, 78, 127, 0.05) 100%);
}
.ready-to-run-screen .p-55 {
  padding-top: 85px;
  padding-bottom: 85px;
}
.ready-to-run-screen .btn-run-screen {
  background:
    linear-gradient(
      180deg,
      #C845AB 0%,
      #E24E7F 100%);
  border: 1px solid #FFFFFF;
  padding: 12px;
  border-radius: 4px;
  color: #fff;
  height: auto;
  font-size: 14px;
}
.setting-up-screen {
  padding: 55px 0;
}
.btn-trms-light-with-border {
  background-color: #ffffff;
}
.uploadResumeBelowRow {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 12px;
  margin-bottom: 0px;
}
.uploadResumeBelowRow .uploadResumeStepsCard {
  width: calc(33% - 5px);
  border: 1px solid #D9D9D9;
  background-color: rgba(255, 255, 255, 0.3019607843);
  padding: 12px;
}
.uploadResumeBelowRow .uploadResumeStepsCard .fa-regular {
  margin-bottom: 15px;
}
.stepper-container {
  width: 80%;
  display: flex;
  margin: 0 auto;
  margin-top: 40px;
}
.stepper-container .stepper-left {
  width: 50%;
  display: flex;
  justify-content: center;
}
.stepper-container .stepper-left img {
  width: 80%;
}
.stepper-container .stepper-right {
  width: 50%;
}
.stepper-container .stepper-right .step-section {
  width: 100%;
  display: flex;
  position: relative;
}
.stepper-container .stepper-right .step-section .step-no {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  color: #484B59;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
}
.stepper-container .stepper-right .step-section .step-no .step-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
}
.stepper-container .stepper-right .step-section .step-no .step-box i {
  background:
    linear-gradient(
      180deg,
      #9F38F0 0%,
      #E54F7A 100%);
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}
.stepper-container .stepper-right .step-section .step-no.active {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.stepper-container .stepper-right .step-section .step-content {
  padding-left: 18px;
  padding-bottom: 32px;
}
.stepper-container .stepper-right .step-section .step-content p {
  font-size: 14px;
  font-weight: 500;
  color: #484B59;
  margin-bottom: 10px;
}
.stepper-container .stepper-right .step-section .step-content p:nth-of-type(2) {
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 0;
}
.stepper-container .stepper-right .step-section:last-child .step-no::after {
  display: none;
}
.fixedAtTopbeforeStyle {
  position: relative;
}
.fixedAtTopbeforeStyle::before {
  content: "";
  position: fixed;
  top: 55px;
  width: 100%;
  height: 15px;
  background-color: #ecf0f4;
  display: block;
  z-index: 1;
}
.screen-ai-filter-ui {
  background-color: #fff;
  height: calc(100vh - 75px);
  position: sticky;
  top: 70px;
}
.btn-disabled-ui {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  border-color: #cfcfcf !important;
  cursor: not-allowed;
  opacity: 0.7;
}
.btn-disabled-ui i,
.btn-disabled-ui span {
  color: #9e9e9e !important;
}
.sync-btn-disabled-ui {
  color: #9e9e9e !important;
  border-color: #cfcfcf !important;
  cursor: not-allowed;
  opacity: 0.7;
}
.sync-btn-disabled-icon-ui {
  background: none !important;
  -webkit-background-clip: initial !important;
  background-clip: initial !important;
  -webkit-text-fill-color: #9e9e9e !important;
  color: #9e9e9e !important;
}
.page-selection {
  color: #484b59;
  position: absolute;
  right: 0;
  margin-right: 30px;
}
.page-selection select {
  gap: 4px;
  margin: 0 7px 0 6px;
  padding: 4px 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.sticky-pagination {
  position: sticky;
  bottom: 0;
}
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #68AA86;
  display: flex;
  background:
    linear-gradient(
      0deg,
      rgba(104, 170, 134, 0.1) 0%,
      rgba(104, 170, 134, 0.1) 100%),
    #FFF;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.errror {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  outline: none;
  border: 0px;
  font-size: 12px;
  height: 36px;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
  font-size: 12px;
  font-weight: 500;
  position: relative;
}
.toggle-container .activebtn,
.toggle-container .activeClass {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .insight-btn,
.toggle-container .profile-btn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  position: relative;
  cursor: pointer;
}
.toggle-container .insight-btn:hover,
.toggle-container .profile-btn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .profile-btn.activeClass {
  left: -50%;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.back-link-btn {
  background-color: transparent;
  color: #484b59;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.files-card {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  background: #FCFCFC;
  flex-direction: column;
  margin-bottom: 10px;
}
.btn-svg {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 5px;
}
::ng-deep .progress {
  background-color: #F4F4F4 !important;
  border-radius: 10px !important;
}
::ng-deep .progress-bar {
  border-radius: 10px !important;
}
::ng-deep .progress-bar.text-bg-success {
  background-color: #2E93A1 !important;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 34px;
}
.label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.contact-cta {
  display: flex;
  width: 16px;
  height: 16px;
  padding: 3.326px 3px 2.674px 3px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: #E6F2F4;
}
.helpfull-label {
  display: flex;
  height: 18px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid #F2F2F2;
  background: #FAFAFA;
}
.table-view,
.table-view-3-column {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  overflow: hidden;
}
.table-view .table-header-row,
.table-view .table-body-row,
.table-view-3-column .table-header-row,
.table-view-3-column .table-body-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  background-color: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col,
.table-view .table-header-row .table-body-col,
.table-view .table-body-row .table-header-col,
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  width: 30%;
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  align-content: start;
  border-right: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col:last-child,
.table-view .table-header-row .table-body-col:last-child,
.table-view .table-body-row .table-header-col:last-child,
.table-view .table-body-row .table-body-col:last-child,
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 70%;
}
.table-view .table-header-row .table-header-col:first-child,
.table-view .table-header-row .table-body-col:first-child,
.table-view .table-body-row .table-header-col:first-child,
.table-view .table-body-row .table-body-col:first-child,
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 30%;
}
.table-view .table-body-row,
.table-view-3-column .table-body-row {
  background-color: #ffffff;
}
.table-view .table-body-row:last-child,
.table-view-3-column .table-body-row:last-child {
  border-bottom: none;
}
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-body-row .table-body-col {
  color: #5E5E5E;
  font-weight: 400;
}
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  border-right: 1px solid #F2F2F2;
  width: 40%;
  align-content: start;
  gap: 0;
}
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 40%;
}
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 24%;
}
::ng-deep ngb-pagination .pagination .page-item a.page-link {
  font-size: 12px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: 500px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
.hire-search-card-filters {
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  height: 80vh;
}
.toggle-container2 {
  position: relative;
  display: inline-flex;
  background: #e5e5e5;
  border-radius: 20px;
  padding: 4px;
  cursor: pointer;
}
.toggle-container2 span {
  position: relative;
  z-index: 2;
  padding: 6px 16px;
  font-size: 14px;
  color: #555;
  transition: color 0.3s ease;
}
.toggle-container2 span.active {
  color: #fff;
}
.toggle-slider2 {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 50%;
  height: calc(100% - 8px);
  background: #28a745;
  border-radius: 20px;
  transition: transform 0.3s ease;
  z-index: 1;
  color: #fff;
}
.toggle-slider2.insights {
  transform: translateX(100%);
}
.toggle-slider2.profiles {
  transform: translateX(0%);
}
.ml-auto {
  margin-left: auto;
}
.pos-sticky-top {
  position: sticky;
  top: 16px;
  z-index: 7;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.05);
}
.pos-sticky-top::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 16px;
  background-color: #fafbfc;
  top: -16px;
  left: 0;
}
.pipeline-export-modal-content {
  border-radius: 7px !important;
  overflow: hidden;
}
.pipeline-export-modal-content .modal-header {
  background-color: #f7f8f9;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
}
.pipeline-export-modal-content .modal-header .btn-close {
  background-color: #f7f8f9;
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-modal-content .modal-header .btn-close:focus,
.pipeline-export-modal-content .modal-header .btn-close:active {
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-options {
  display: flex;
  flex-direction: column;
}
.pipeline-export-options .pipeline-export-option {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.25rem;
  font-size: 13px;
  color: #484b59;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.pipeline-export-options .pipeline-export-option:last-child {
  border-bottom: none;
}
.pipeline-export-options .pipeline-export-option:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
.pipeline-export-options .pipeline-export-option.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.pipeline-export-options .pipeline-export-option-icon {
  width: 20px;
  margin-right: 10px;
  text-align: center;
  color: #969696;
}
.chip-dropdown {
  display: inline-block;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 4px 8px 4px 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
}
.chip-dropdown .fa-caret-down {
  transition: rotate 0.2s ease;
}
.chip-dropdown .dropdown-menu.show {
  background-color: #fff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #484b59;
  border: none;
  padding: 4px 0;
  font-size: 12px;
}
.chip-dropdown .dropdown-menu.show .dropdown-item {
  font-size: 12px;
}
.chip-dropdown .dropdown-menu.show .dropdown-item:hover {
  background-color: #EAF6F4;
  color: #484b59;
}
.chip-dropdown .dropdown-menu.show .dropdown-item:focus {
  background-color: #EAF6F4;
  color: #484b59;
}
.chip-dropdown .dropdown-menu.show .dropdown-item:active {
  background-color: #EAF6F4;
  color: #484b59;
}
.chip-dropdown.show .fa-caret-down {
  transition: rotate 0.2s ease;
  transform: rotate(180deg);
}
.chip-toggle {
  color: inherit;
  text-decoration: none;
}
.chip-text {
  font-weight: 500;
}
.active-chip {
  background: #EAF6F4;
  color: rgb(76, 102, 69);
}
.active-chip .chip-text {
  color: #2CA28E;
}
.active-chip .chip-text:hover {
  color: #2CA28E;
}
.active-chip .fa-caret-down {
  color: #2CA28E;
}
.inactive-chip {
  background: #F4F4F4;
  color: rgb(150, 150, 150);
}
.inactive-chip .chip-text {
  color: #484b59;
}
.inactive-chip .chip-text:hover {
  color: #484b59;
}
.inactive-chip .fa-caret-down {
  color: #484b59;
}
.dropdown-menu {
  min-width: 120px !important;
}
.dropdown-item span {
  font-size: 12px;
  font-weight: 500;
  color: #484b59;
}
.dropdown-toggle::after {
  border: none !important;
}
.btn-trms-medium {
  padding: 6px 8px;
  height: auto;
}
.btn-trms-medium.disabled {
  pointer-events: none;
  background-color: #cccccc;
  border: none;
}
.chip-dropdown-disabled {
  display: inline-block;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 4px 12px 4px 12px;
  height: 26px;
  font-size: 12px;
  font-weight: 500;
}
.dropdown-toggle::after {
  display: none;
}
span.dropdown-menu.show {
  position: absolute;
  left: -5px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.17);
  border: none;
  top: 8px !important;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 0;
  width: fit-content;
  padding: 0px !important;
  left: 0px !important;
  transform: translate3d(-112px, -3px, 12px) !important;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  color: #484b59;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item i {
  color: #484b59 !important;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item span {
  color: #484b59;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item span .mysvg path {
  fill: #484b59;
  transition: fill 0.3s ease;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #EAF4F6;
  color: #2E93A1;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover i {
  color: #2E93A1 !important;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover span {
  color: #2E93A1;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover span .mysvg path {
  fill: #2E93A1;
  transition: fill 0.3s ease;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.btn-trms-small.bg-gray {
  background-color: #969696 !important;
  color: #fff !important;
  border: 0px !important;
}
.page-selection {
  color: #484b59;
  position: absolute;
  right: 0;
  margin-right: 30px;
}
.page-selection select {
  gap: 4px;
  margin: 0 7px 0 6px;
  padding: 4px 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.sticky-pagination {
  position: sticky;
  bottom: 0;
}
.last-activity .btn-trms-white {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  background: #FFF;
  color: #484b59;
  padding: 6px 6px;
  font-size: 12px;
  transition: rotate 0.2s ease-in;
}
.last-activity .btn-trms-white span {
  transform: rotate(0deg);
  display: inline-flex;
}
.last-activity .btn-trms-white.show {
  transition: rotate 0.2s ease-in;
}
.last-activity .btn-trms-white.show span {
  transform: rotate(180deg);
}
.last-activity .dropdown-menu.show {
  font-size: 12px;
  color: #484b59;
  border: none;
}
.last-activity .dropdown-menu.show .radio-custom-label {
  position: relative;
  width: 215px;
  padding: 6px 12px;
  font-size: 12px;
  margin: 0;
  font-weight: normal;
}
.last-activity .dropdown-menu.show .radio-custom-label:hover {
  background-color: #FAFAFA;
}
.last-activity .dropdown-menu.show .radio-custom-label:before {
  content: "";
  background: #fff;
  border: 1px solid #2E93A1;
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  padding: 0px 0 0 1px;
  margin-right: 10px;
  text-align: center;
  position: absolute;
  right: 0;
  font-size: 8px;
}
.filter-icon .filter-btn {
  padding: 10px;
}
.project-list-container {
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: #ffffff;
  overflow: visible;
}
.project-list-container .project-list-header {
  background-color: rgba(239, 241, 243, 0.5);
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}
.project-list-container .project-list-header .header-item {
  padding: 10.234px 12.515px;
  color: #5E5E5E;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.project-list-container .project-list {
  border-bottom: 1px solid #f2f2f2;
}
.project-list-container .project-list:hover {
  background-color: #FAFAFA;
}
.project-list-container .project-list:hover .ats-dropBtn button {
  background-color: #FAFAFA;
}
.project-list-container .project-list:last-child {
  border-bottom: none;
}
.project-list-container .project-list .list-item {
  padding: 10.234px 12.515px;
  color: #5E5E5E;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.project-list-container .project-list .list-item .owner {
  color: #969696;
  display: flex;
  font-size: 12px;
}
.searchInputbox {
  position: relative;
}
.searchInputbox .search-icon {
  position: absolute;
  left: 12px;
  top: 5px;
}
.searchInputbox input[type=text] {
  padding-left: 36px;
}
#projectDetails .nav-link.active {
  color: #2E93A1;
  font-weight: bold;
  border-bottom: 2px solid #2E93A1;
  padding: 8px 16px;
  border-radius: 0px;
  font-weight: 600;
  transition: font-weight 0.2s ease-in;
}
#projectDetails .nav-link {
  border-radius: 0px;
  background-color: #fff;
  color: #969696;
  font-weight: 400;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 400;
  border-bottom: 2px solid #fff;
  transition: font-weight 0.2s ease-in;
  display: flex;
  align-items: center;
}
.pl-count {
  display: flex;
  width: fit-content;
  min-width: 24px;
  height: 24px;
  padding: 5.143px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8.571px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  border-radius: 85.714px;
  background: rgba(150, 150, 150, 0.1);
}
.nav-link.active .pl-count {
  background-color: rgba(46, 147, 161, 0.1);
}
select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 24px 6px 10px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 34px;
}
.dropdown-caret,
.dropdown-caret2 {
  position: relative;
  width: fit-content;
}
.dropdown-caret::after,
.dropdown-caret2::after {
  content: "";
  display: flex;
  position: absolute;
  right: 6px;
  top: 8px;
  width: 18px;
  height: 18px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
.dropdown-caret:focus::after,
.dropdown-caret2:focus::after {
  transform: rotate(180deg);
}
.custom-select {
  min-width: 50px;
  width: 125px;
  padding: 8px 24px 6px 10px;
  border: 1px solid #f2f2f2;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #484b59;
}
.custom-select:focus {
  outline: none;
  border-color: #007bff;
}
select.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 125px;
}
.dropdown-caret.bg-img-rotate-caret::after {
  transform: rotate(180deg);
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
}
.criteria-label {
  display: flex;
  height: 24px;
  padding: 6px 9px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 14px;
  background-color: #F5F5F5;
  font-size: 12px;
  font-weight: 500;
}
.criteria-label.talentpool {
  color: #2E93A1;
  background-color: rgba(56, 164, 175, 0.1019607843);
}
.criteria-label.autopilot {
  color: #D74B92;
  background-color: rgba(215, 75, 146, 0.1019607843);
}
::ng-deep ngb-pagination ul.pagination {
  font-size: 12px !important;
}
::ng-deep ngb-pagination ul.pagination li.page-item {
  font-size: 12px !important;
}
::ng-deep ngb-pagination ul.pagination li.page-item a.page-link {
  font-size: 12px !important;
}
.pipeline-export-modal-content {
  border-radius: 7px !important;
  overflow: hidden;
}
.pipeline-export-modal-content .modal-header {
  background-color: #f7f8f9;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
}
.pipeline-export-modal-content .modal-header .btn-close {
  background-color: #f7f8f9;
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-modal-content .modal-header .btn-close:focus,
.pipeline-export-modal-content .modal-header .btn-close:active {
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-options {
  display: flex;
  flex-direction: column;
}
.pipeline-export-options .pipeline-export-option {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.25rem;
  font-size: 13px;
  color: #484b59;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.pipeline-export-options .pipeline-export-option:last-child {
  border-bottom: none;
}
.pipeline-export-options .pipeline-export-option:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
.pipeline-export-options .pipeline-export-option.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.pipeline-export-options .pipeline-export-option-icon {
  width: 20px;
  margin-right: 10px;
  text-align: center;
  color: #969696;
}
.pipeline-export-dropbtn {
  display: inline-flex;
}
.pipeline-export-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  outline: none;
  background-color: #fff;
  color: #969696;
}
.pipeline-export-toggle::after {
  display: none;
}
.pipeline-export-toggle:hover {
  background-color: #f3f3f3;
}
.pipeline-export-menu.dropdown-menu {
  min-width: 170px;
  padding: 6px 0;
  border: none;
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.18);
}
.pipeline-export-item.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 13px;
  color: #484b59;
}
.pipeline-export-item.dropdown-item:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
/*# sourceMappingURL=my-candidates.component-SHVOB2ZR.css.map */
